import {FundraisingUiState} from './FundraisingUiState.model';
import {DocumentsUiState} from './DocumentsUiState.model';
import {ContactsUiState} from './ContactsUiState.model';
import {BankAccountsUiState} from './BankAccountsUiState.model';
import {CreBankAccountsUiState} from './CreBankAccountsUiState.model';
import {PositionsReportUiState} from './PositionsReportUiState.model';
import {AssetsUiState} from './AssetsUiState.model';
import {FundsUiState} from './FundsUiState.model';
import {SimpleSortUiState} from './SimpleSortUiState.model';
import {InsightsUiState} from './InsightsUiState.model';
import {OfferingDeckEngagementUiState} from './OfferingDeckEngagementUiState.model';
import {BankApplicationsUiState} from './BankApplicationsUiState.model';
import {PaymentsUiState} from './PaymentsUiState.model';
import {PromoUiState} from './PromoUiState.model';
import {CommitmentsUiState} from './Commitments.model';

export class ClientPresentationState {
  public assets: AssetsUiState;
  public funds: FundsUiState;
  public fundraising: FundraisingUiState;
  public documents: DocumentsUiState;
  public contacts: ContactsUiState;
  public recipientContacts: ContactsUiState;
  public gpBankAccounts: BankAccountsUiState;
  public investorsBankAccounts: CreBankAccountsUiState;
  public bankApplications: BankApplicationsUiState;
  public positionsReport: PositionsReportUiState;
  public fundsManagingPortfolio: SimpleSortUiState;
  public fundsManagingOverview: SimpleSortUiState;
  public assetInvestorOverview: SimpleSortUiState;
  public commitments: CommitmentsUiState;
  public fundsFundraising: SimpleSortUiState;
  public assetsFundraising: SimpleSortUiState;
  public fundsDistribution: SimpleSortUiState;
  public assetsDistribution: SimpleSortUiState;
  public insightsInvestorInteractions: SimpleSortUiState;
  public insightsUiState: InsightsUiState;
  public offeringDeckEngagementUiState: OfferingDeckEngagementUiState;
  public payments: PaymentsUiState;
  public promo: PromoUiState;

  constructor() {
    this.assets = new AssetsUiState();
    this.funds = new FundsUiState();
    this.fundraising = new FundraisingUiState();
    this.documents = new DocumentsUiState();
    this.contacts = new ContactsUiState();
    this.recipientContacts = new ContactsUiState();
    this.gpBankAccounts = new BankAccountsUiState();
    this.investorsBankAccounts = new CreBankAccountsUiState();
    this.bankApplications = new BankApplicationsUiState();
    this.positionsReport = new PositionsReportUiState();
    this.fundsManagingPortfolio = new SimpleSortUiState();
    this.fundsManagingOverview = new SimpleSortUiState();
    this.assetInvestorOverview = new SimpleSortUiState();
    this.commitments = new CommitmentsUiState();
    this.fundsFundraising = new SimpleSortUiState();
    this.assetsFundraising = new SimpleSortUiState();
    this.fundsDistribution = new SimpleSortUiState();
    this.assetsDistribution = new SimpleSortUiState();
    this.insightsInvestorInteractions = new SimpleSortUiState();
    this.insightsUiState = new InsightsUiState();
    this.offeringDeckEngagementUiState = new OfferingDeckEngagementUiState();
    this.payments = new PaymentsUiState();
    this.promo = new PromoUiState();
  }

  static fromJson(obj: ClientPresentationState): ClientPresentationState {
    const model = new ClientPresentationState();
    if (!obj) {
      return model;
    }

    model.assets = obj.assets ? AssetsUiState.fromJson(obj.assets) : new AssetsUiState();
    model.funds = obj.funds ? FundsUiState.fromJson(obj.funds) : new FundsUiState();
    model.fundraising = obj.fundraising ? FundraisingUiState.fromJson(obj.fundraising) : new FundraisingUiState();
    model.documents = obj.documents ? DocumentsUiState.fromJson(obj.documents) : new DocumentsUiState();
    model.contacts = obj.contacts ? ContactsUiState.fromJson(obj.contacts) : new ContactsUiState();
    model.recipientContacts = obj.recipientContacts ? ContactsUiState.fromJson(obj.recipientContacts) : new ContactsUiState();
    model.gpBankAccounts = obj.gpBankAccounts ? BankAccountsUiState.fromJson(obj.gpBankAccounts) : new BankAccountsUiState();
    model.investorsBankAccounts = obj.investorsBankAccounts ? CreBankAccountsUiState.fromJson(obj.investorsBankAccounts) : new CreBankAccountsUiState();
    model.bankApplications = obj.bankApplications ? BankApplicationsUiState.fromJson(obj.bankApplications) : new BankApplicationsUiState();
    model.positionsReport = obj.positionsReport ? PositionsReportUiState.fromJson(obj.positionsReport) : new PositionsReportUiState();
    model.fundsManagingPortfolio = obj.fundsManagingPortfolio ? SimpleSortUiState.fromJson(obj.fundsManagingPortfolio) : new SimpleSortUiState();
    model.fundsManagingOverview = obj.fundsManagingOverview ? SimpleSortUiState.fromJson(obj.fundsManagingOverview) : new SimpleSortUiState();
    model.assetInvestorOverview = obj.assetInvestorOverview ? SimpleSortUiState.fromJson(obj.assetInvestorOverview) : new SimpleSortUiState();
    model.commitments = obj.commitments ? CommitmentsUiState.fromJson(obj.commitments) : new CommitmentsUiState();
    model.fundsFundraising = obj.fundsFundraising ? SimpleSortUiState.fromJson(obj.fundsFundraising) : new SimpleSortUiState();
    model.assetsFundraising = obj.assetsFundraising ? SimpleSortUiState.fromJson(obj.assetsFundraising) : new SimpleSortUiState();
    model.fundsDistribution = obj.fundsDistribution ? SimpleSortUiState.fromJson(obj.fundsDistribution) : new SimpleSortUiState();
    model.assetsDistribution = obj.assetsDistribution ? SimpleSortUiState.fromJson(obj.assetsDistribution) : new SimpleSortUiState();
    model.insightsInvestorInteractions = obj.insightsInvestorInteractions ? SimpleSortUiState.fromJson(obj.insightsInvestorInteractions) : new SimpleSortUiState();
    model.insightsUiState = obj.insightsUiState ? InsightsUiState.fromJson(obj.insightsUiState) : new InsightsUiState();
    model.offeringDeckEngagementUiState = obj.offeringDeckEngagementUiState ? OfferingDeckEngagementUiState.fromJson(obj.offeringDeckEngagementUiState) : new OfferingDeckEngagementUiState();
    model.payments = obj.payments ? PaymentsUiState.fromJson(obj.payments) : new PaymentsUiState();
    model.promo = obj.promo ? PromoUiState.fromJson(obj.promo) : new PromoUiState();

    return model;
  }
}
